import request from '@/utils/request.js'
const urlGetway = '/proxy-gateway/gw-core'
export function batchCodeSearchDynamic(data) {
  return request({
    url: `${urlGetway}/product-batch/search-dynamic`,
    method: 'post',
    data,
  })
}